const STORAGE_KEY = 'instagram-autobot.selectedAccountId'

export function getStoredAccountId() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch (error) {
    console.warn('Failed to read stored account id', error)
    return null
  }
}

export function setStoredAccountId(accountId) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    if (accountId) {
      window.localStorage.setItem(STORAGE_KEY, accountId)
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch (error) {
    console.warn('Failed to persist account id', error)
  }
}

export function clearStoredAccountId() {
  setStoredAccountId(null)
}
